import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { NgxBootstrapModule } from "../../ngx-bootstrap/ngx-bootstrap.module";

@Component({
  selector: 'app-time-input-v3',
  templateUrl: './time-input-v3.component.html',
  styleUrls: ['./time-input-v3.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    NgxBootstrapModule
],
})
export class TimeInputV3Component{
  @Input() label = 'Time';
  @Input() name = 'time';
  @Input() required = false;
  @Input() timeValue = '';
  @Input() format: 12 | 24 = 24;
  @Input() min: string | null = null; // HH:mm
  @Input() disabled = false;


  @Output() timeValueChange = new EventEmitter<string>();
  @Output() timeChanged = new EventEmitter<string>();


  /** Se dispara en cada cambio del input */
  onTimeChange(value: string): void {
  this.timeValue = value;
  this.timeValueChange.emit(value);
  this.timeChanged.emit(value);
  }


  clearTimeValue(): void {
  this.onTimeChange('');
  }


  /** Para compatibilidad semántica con v2 */
  onTimeSet(value: string): void {
  this.onTimeChange(value);
  }
}